export const userDataMutation = (builder) => ({
  userData: builder.mutation({
    query: ({ pageNumber, limit, user_type, search, status, sortBy, sortOrder, }) => {
      const token = JSON.parse(localStorage.getItem('TOKEN'))?.token || '';

      return {
        url: '/user_data',
        method: 'GET',
        params: { pageNumber, limit, user_type, search, status, sortBy, sortOrder, },
        headers: {
          'Content-Type': 'application/json',
          'Authorization': token
        },
      };
    },
  }),
});
